import { StyleSheet } from 'aphrodite';
import { brandPrimaryText } from '../../../web/styles/colors';
import { DefaultBorder, truncateTextStyle } from '../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	accountListStatusColor: {
		marginRight: 28,
		width: 12,
	},
	accountName: {
		alignItems: 'center',
		display: 'flex',
	},
	accountRowName: {
		cursor: 'pointer',
		flexGrow: 1,
		width: 275,
	},
	andMore: {
		color: '#C9C9C9',
	},
	column: {
		flexGrow: 0.5,
		fontSize: 12,
		margin: '0 20px',
		width: 80,
	},
	columnLast: {
		flexGrow: 0.3,
		fontSize: 12,
		marginLeft: 20,
		width: 80,
	},
	companyName: {
		color: brandPrimaryText,
		cursor: 'pointer',
		fontSize: 18,
		fontWeight: 600,
		textDecoration: 'none',
		width: 275,
		...truncateTextStyle,
	},
	container: {
		alignItems: 'center',
		borderTop: DefaultBorder,
		display: 'flex',
		minHeight: 50,
		padding: '15px 10px 15px 0',
		textAlign: 'left',
	},
	emailDomain: {
		color: '#858585',
		cursor: 'initial',
		fontSize: 14,
		marginTop: 6,
	},
	flagIcon: {
		height: 18,
		marginLeft: 16,
		width: 17,
	},
	unassigned: {
		color: '#F89143',
	},
});
